import { IconProps } from '@/components/Icon';

export const IconUndo = ({ width = 14, height = 14, color = 'currentColor', ...props }: IconProps) => {
  return (
    <svg {...props} fill='none' height={height} width={width} xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M5.25 8.75L1.75 5.25M1.75 5.25L5.25 1.75M1.75 5.25H8.75C9.67826 5.25 10.5685 5.61875 11.2249 6.27513C11.8813 6.9315 12.25 7.82174 12.25 8.75C12.25 9.67826 11.8813 10.5685 11.2249 11.2249C10.5685 11.8813 9.67826 12.25 8.75 12.25H7'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='1.5'
      />
    </svg>
  );
};
